export default __webpack_public_path__ + "static/media/Exp_Sharing.16b85071.jpeg";